import constants from '@/constants';

const isImage = (s3Key) => {
  if (!s3Key) {
    return false;
  }

  const index = s3Key.lastIndexOf('.');

  return index >= 0 && constants.imageExtensions.includes(s3Key.slice(index + 1).toLowerCase());
};

export default isImage;



// WEBPACK FOOTER //
// ./src/utils/isImage.js